module.exports = __webpack_public_path__ + "img/map_third-base-patio-2.31dc7206.jpg";